module.exports = __webpack_public_path__ + "img/introducer-en-ca.54df0c4a.jpg";